module.exports = __webpack_public_path__ + "static/img/loading.3e6da18.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/loading.gif
// module id = wOw2
// module chunks = 1